import styled from "@emotion/styled";
import React, { CSSProperties } from "react";
import Text from "@src/components/Text";
import { MOBILE_BREAKPOINT } from "@src/hooks/useIsMobile";

type ITab = {
  name: string;
};

interface IProps {
  tabs: ITab[];
  activeTab: number;
  setActive: (index: number) => void;
  style?: CSSProperties;
  tabStyle?: CSSProperties;
}

const Root = styled.div`
  display: flex;
  /* Wrap onto multiple lines on desktop so a long tab set never overflows
     the screen. Only triggers when the tabs don't fit on one line. */
  flex-wrap: wrap;
  row-gap: 4px;
  border-bottom: 1px solid #ebeeef;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    /* On mobile keep a single scrollable row instead of wrapping. */
    flex-wrap: nowrap;
    row-gap: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      height: 4px;
    }
  }
`;
const Tab = styled.div<{ active?: boolean }>`
  font-family: Nunito Sans, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 24px;
  transition: all 0.3s ease;
  text-align: center;
  padding: 0 24px 14px 24px;
  border-bottom: 2px solid #EBEEEF;
  cursor: pointer;
  color: ${({ active }) => (active ? "#181B1F" : "#899093")};
  border-bottom: ${({ active }) =>
    active ? `2px solid #68AD18` : "2px solid transparent"};
  user-select: none;
  white-space: nowrap;
  flex-shrink: 0;
  :hover {
    border-bottom: ${({ active }) => !active && `2px solid #68AD18`}
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0 16px 12px 16px;
    font-size: 14px;
  }
`;
const Tabs: React.FC<IProps> = ({
  tabs,
  activeTab,
  setActive,
  style,
  tabStyle,
}) => {
  return (
    <Root style={style}>
      {tabs.map(({ name }, index) => (
        <Tab
          key={index}
          active={index === activeTab}
          onClick={() => setActive(index)}
          style={tabStyle}
        >
          <Text size={15} type="heading">
            {name}
          </Text>
        </Tab>
      ))}
    </Root>
  );
};
export default Tabs;
